import React from 'react';
import Loadable from 'react-loadable';
import LinearProgress from '@material-ui/core/LinearProgress';
import { useSelector } from 'react-redux';
import { Redirect, useParams } from 'react-router';

import { selectUser } from 'entities/user/selectors';
import { Features } from 'utils/features';

const createLoadable = (loader: Promise<any>) =>
  Loadable({
    // eslint-disable-next-line no-console
    loader: () =>
      loader
        .then((module) => module.default || module)
        .catch(() => console.error('Failed to load dashboard')),
    loading: () => <LinearProgress />,
  });

const SigmaDashboardComponent = createLoadable(import('../SigmaDashboardPage'));
type RouteParams = { type: string };

export default () => {
  const user = useSelector(selectUser);

  const { type } = useParams<RouteParams>();
  if (!type) {
    if (user?.hasFeature(Features.DONATIONS)) {
      return <Redirect to="/dashboards/donations" />;
    } else if (user?.hasFeature(Features.VOLUNTEERING)) {
      return <Redirect to="/dashboards/volunteering" />;
    } else {
      return <Redirect to="/dashboards/engagement" />;
    }
  }

  return <SigmaDashboardComponent />;
};
